module.exports = __webpack_public_path__ + "img/background01.0c241b8b.png";